const timestampFor = (play, published) => {
  const values = published
    ? [play?.published_at, play?.updated_at, play?.created_at]
    : [play?.updated_at, play?.created_at];
  for (const value of values) {
    const timestamp = Date.parse(value || "");
    if (Number.isFinite(timestamp)) return timestamp;
  }
  return 0;
};

const newest = (plays, published) => [...plays].sort((a, b) =>
  timestampFor(b, published) - timestampFor(a, published) ||
  String(b?.id || "").localeCompare(String(a?.id || ""))
)[0] || null;

export function selectCurrentGuruPlay(plays = []) {
  const active = plays.filter((play) => ["DRAFT", "PUBLISHED"].includes(play?.publication_state));
  const published = active.filter((play) => play.publication_state === "PUBLISHED");
  return published.length ? newest(published, true) : newest(active, false);
}

export function canOfferDraftDeletion(play) {
  return Boolean(play && play.publication_state === "DRAFT" && !play.published_at);
}
